/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useState, useEffect } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/DashboardNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { checkSession, getAccountApps } from "../network/ApiAxios";
import { useNavigate } from "react-router-dom";
import  secureLocalStorage  from  "react-secure-storage";
import { getFilteredRoutes } from "routes.js";


import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const DashboardAdmin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const [redirect, setRedirect] = useState();
  const [app, setApp] = useState();
  const filteredRoutes = getFilteredRoutes();

  const isHomePage = location.pathname === '/admin/index';
  const isUserProfile = location.pathname === '/admin/user-profile';

  React.useEffect(() => {
    document.title = 'FSK - Central System';
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;

    const runAsync = async () => {

      const response = await checkSession();
      const { data } = response;


      const storedApp = secureLocalStorage.getItem("app");
      let currentApp = storedApp ? JSON.parse(storedApp) : null;

      if(!currentApp){
        let params = {
          filter: {
            account: user.account
          }
        }

        const appResponse = await getAccountApps(params);
        const { data : appData } = appResponse;
        
        if (appData.success && appData.account.apps.length > 0) {
          let apps = appData.account.apps
          currentApp = apps[0]; // Pega o primeiro app
          
          // Salva no state e no localStorage
          setApp(currentApp);
          secureLocalStorage.setItem("app", JSON.stringify(app));

        }
      }

      if (user && !data.success) {

        setRedirect(true)

      }

    }
    runAsync();

  }, [location, app]);


  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (user && prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = () => {
    
    for (let i = 0; i < filteredRoutes.length; i++) {
      let target = (filteredRoutes[i].layout + filteredRoutes[i].path)
      let thereIsParams = target.indexOf(':')

      target = target.substring(0, thereIsParams > -1 ? thereIsParams : target.length);

      if (window.location.pathname.toLowerCase().indexOf(target.toLowerCase()) !== -1) {
        return filteredRoutes[i].name + ' ' + filteredRoutes[i].complement;
      }
    }
    return "Brand";
  };

  let loadRoutes = () => {
    if (!user || redirect) {
      setTimeout(() => {
        navigate('/auth/login');
      }, 8000);

      return (
        <>
          <div className="main-content" ref={mainContent}>
            <div className="header bg-white py-7 py-lg-8">
              <Container>
                <div className="header-body text-center mb-7">
                  <Row className="justify-content-center">
                    <Col lg="5" md="6">
                        <div className="w-80 mx-auto">
                          <DotLottieReact
                            src="https://lottie.host/802d21eb-3009-4772-a323-baa6ef6b6dfc/yEoMwVYF1c.lottie"
                            loop
                            autoplay
                          />
                        </div>
                      <h1 className="text-black">Welcome!</h1>
                      <p className="text-lead text-dark">
                        To continue, please log in. We're now redirecting you to the login page.
                      </p>
                      <p>
                        You can also
                        <a
                            className="text-dark"
                            style={{cursor: 'pointer'}}
                            onClick={() =>  navigate('/auth/login')}
                        >
                            <strong> click here </strong>
                        </a>
                        to go to the login page.
                      </p>

                    </Col>
                  </Row>
                </div>
              </Container>
            </div>
          </div>
        </>
      )
    }

    if (isHomePage) {
      // Layout sem sidebar para a home
      return (
        <>
          <div className="main-content full-width" ref={mainContent}>
            
            <Routes>
              {getRoutes(filteredRoutes)}
              <Route path="*" element={<Navigate to="/admin/index" replace />} />
            </Routes>
          </div>
        </>
      );
    }

    // Layout padrão com sidebar para outras páginas
    return (
      <>
        <Sidebar
          {...props}
          routes={filteredRoutes}
          logo={{
            innerLink: "/admin/index",
            imgSrc: require("../assets/img/brand/FSK-Inverted.png"),
            imgAlt: "FSK",
          }}
        />

        <div className="main-content" ref={mainContent}>

          {!isUserProfile && <AdminNavbar {...props} brandText={getBrandText()} />}
          
          
          <Routes>
            {getRoutes(filteredRoutes)}
            <Route path="*" element={<Navigate to="/admin/index" replace />} />
          </Routes>

          {/* <Container fluid>
            <AdminFooter />
          </Container> */}
        </div>
      </>
    )
  }

  return (
    <>

      {loadRoutes()}

    </>
  );
};

export default DashboardAdmin;
